import {Component, Inject, OnInit} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FilterDTO } from '../../models/FilterDTO';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { ToastrService } from "ngx-toastr";
import { CustomValidators } from "src/app/features/shared/helpers/utilities/CustomValidators";
import { SessionService } from "src/app/features/shared/services/Session.service";

@Component({
    selector: "filter-map",
    templateUrl: "./filter-map.component.html",
    styleUrls: ["./filter-map.component.css"],
})
export class FilterMapComponent implements OnInit {
    form: FormGroup;
    filters: any = [] = [];
    valuesFiltered : any[] = [];

    isAvailabilityFilter: boolean = false;
    selectedInitialDate: Date = null;
    selectedFinalDate: Date = null;
    min: Date = new Date();
    selectedCategories : number[] = [];
    categoriesList : any[] = [];

    constructor(
        public dialogRef : MatDialogRef<FilterMapComponent>,
        private sessionService : SessionService,
        private toastService : ToastrService,
        @Inject(MAT_DIALOG_DATA) private data: any) {
            console.log('ava data', data);

            this.categoriesList = JSON.parse(localStorage.getItem('listaCategorias'));
            this.categoriesList = this.categoriesList.filter(category => !category.itWorksAsGPS)
        
            this.filters = data.filters.sort((a, b) => (a.key < b.key ? -1 : 1));
            this.valuesFiltered = data.selected;

            this.isAvailabilityFilter = data.isAvailabilityFilter;
            this.selectedCategories = data.selectedCategories;

            if (data.selectedInitialDate != null && data.selectedFinalDate != null) {
                this.selectedInitialDate = new Date(data.selectedInitialDate);
                this.selectedFinalDate = new Date(data.selectedFinalDate);
            }

            const group: any = {};
            this.filters.forEach(element => {
                if (this.valuesFiltered.some(x => x.key == element.key)) {
                    element.selected = data.selected[this.valuesFiltered.findIndex(x => x.key == element.key)].value;
                } else {
                    element.selected = '';
                }
                group[element.key] = new FormControl(element.selected);
            });
            
            if (this.isAvailabilityFilter) {
                // Añadir los controles para fecha inicial y final
                group['initialDate'] = new FormControl(this.selectedInitialDate, Validators.required);
                group['finalDate'] = new FormControl(this.selectedFinalDate, Validators.required);
                group['categories'] = new FormControl(this.selectedCategories);

                this.form = new FormGroup(group, CustomValidators.DateLessThan('initialDate', 'finalDate'));
            }else{
                this.form = new FormGroup(group);
            }
    }

    ngOnInit(): void {
        this.checkingURL();
    }

    checkingURL() {
        this.sessionService.CheckURLSource();
    }

    addFilter($filter: FilterDTO) {        
        if(this.filters.some(x => x.key == $filter.key)) {
            const valueIndex = this.valuesFiltered.findIndex(x => x.key == $filter.key);
            if(valueIndex == -1){
                this.valuesFiltered.push({key: $filter.key, value: $filter.value})
            } else {
                this.valuesFiltered[valueIndex].value = $filter.value;
            }
        }
    }

    dropFilter($filter: FilterDTO) {
        const valueIndex = this.valuesFiltered.findIndex(x => x.key == $filter.key);
        if(valueIndex >= 0) {
            this.valuesFiltered.splice(valueIndex, 1);
        }
    }

    limteFecha(event: MatDatepickerInputEvent<Date>) {
          this.min = event.value;
      }

    clear() {
        this.form.reset();
        this.filters.forEach(element => {
            element.selected = '';
        });
        this.valuesFiltered = [];
        this.dialogRef.close({ search: true, filtersSelected: this.valuesFiltered, initialDate: null, finalDate: null });
    }

    cancel(){
        this.dialogRef.close({ search: false });
    }

    accept() {
        if (this.isAvailabilityFilter) {
           
            this.form.updateValueAndValidity();
            if (this.form.invalid) {
                this.toastService.error('Se necesita rellenar la fecha inicial y final', 'Error');
                return;
            }
            //fechas
            this.selectedInitialDate = this.form.value.initialDate;
            this.selectedFinalDate = this.form.value.finalDate;

            //categorias
            const selectedCategoriesList : number[] = this.form.controls['categories'].value;
            const categoriesList = JSON.parse(localStorage.getItem('listaCategorias'));
            console.log('categoriesList', selectedCategoriesList, categoriesList);
            
            var isVisibleGPSTabs = false;
            if (selectedCategoriesList == null || selectedCategoriesList.length == 0) {
                categoriesList.forEach(category => {
                    if(!category.itWorksAsGPS){
                        selectedCategoriesList.push(category.id);
                    }
                    console.log('FILTRO AVA all', category, selectedCategoriesList);
                    
                });
            }
            // if(selectedCategoriesList.includes(0) && !selectedCategoriesList.includes(1)){
            //     selectedCategoriesList.splice(selectedCategoriesList.indexOf(0), 1);
            //     categoriesList.forEach(category => {
            //         if(category.itWorksAsGPS){
            //             selectedCategoriesList.push(category.id);
            //         }
            //         console.log('FILTRO AVA categorias 0', category, selectedCategoriesList);
                    
            //     });
            // }else{
            //     if (selectedCategoriesList.includes(1)) {
            //         categoriesList.forEach(category => {
            //             if(category.itWorksAsGPS){
            //                 if (selectedCategoriesList.indexOf(category.id) != -1) {
            //                     selectedCategoriesList.splice(selectedCategoriesList.indexOf(category.id), 1);
            //                 }
            //             }
            //         });
            //     }else{
            //         isVisibleGPSTabs = false;
            //     }
            // }
            this.selectedCategories = selectedCategoriesList;
            console.log('FILTRO AVA 1', { search: true, filtersSelected: this.valuesFiltered, initialDate: this.selectedInitialDate, finalDate: this.selectedFinalDate, selectedCategories: this.selectedCategories, isVisibleGPSTabs: isVisibleGPSTabs });
            this.dialogRef.close({ search: true, filtersSelected: this.valuesFiltered, initialDate: this.selectedInitialDate, finalDate: this.selectedFinalDate, selectedCategories: this.selectedCategories, isVisibleGPSTabs: isVisibleGPSTabs });
        }else{
            this.dialogRef.close({ search: true, filtersSelected: this.valuesFiltered, initialDate: null, finalDate: null, selectedCategories: null, isVisibleGPSTabs: true });
        }
        
    }
}
